import { axios } from '@/utils/request'

const sysContentMangeApi = {
  queryPageList: '/api/v1/sysContentMange/queryList',
  getInfoById: '/api/v1/sysContentMange/getInfoById',
  addSysContentInfo: '/api/v1/sysContentMange/add',
  editSysContentInfo: '/api/v1/sysContentMange/edit',
  deleteById: '/api/v1/sysContentMange/deleteById',
  getContentResourceByKey: '/api/v1/sysContentMange/getContentResourceByKey',
  getListByDto: '/api/v1/sysContentMange/getListByDto',
  getPurchaseItemLimitNum: '/api/v1/sysContentMange/getPurchaseItemLimitNum',
  getPurchaseItemLimitNumAndConsultTelePhone: '/api/v1/sysContentMange/getPurchaseItemLimitNumAndConsultTelePhone'
}

/**
 *  根据参数查找数据
 * @param query
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const QueryPageList = (query) =>
  axios.get(sysContentMangeApi.queryPageList, { params: { ...query } })

/**
 *  根据ID查找数据
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetInfoById = (id) =>
  axios.get(sysContentMangeApi.getInfoById, { params: { id } })

/**
 * 添加数据
 * @returns {AxiosPromise<any>}
 * @constructor
 * @param data
 */
export const AddSysContentInfo = (data) =>
  axios.post(sysContentMangeApi.addSysContentInfo, data)

/**
 * 修改数据
 * @returns {AxiosPromise<any>}
 * @constructor
 * @param data
 */
export const EditSysContentInfo = (data) =>
  axios.post(sysContentMangeApi.editSysContentInfo, data)

/**
 * 修改数据
 * @returns {AxiosPromise<any>}
 * @constructor
 * @param data
 */
export const DeleteById = (data) =>
  axios.post(sysContentMangeApi.deleteById, data)

/**
 *  根据key和actionType查找系统内容，如系统名称
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetContentResourceByKey = (key, actionType) =>
  axios.get(sysContentMangeApi.getContentResourceByKey, {
    params: { key, actionType }
  })

/**
 * 根据dto查找数据
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetListByDto = (dto) =>
  axios.get(sysContentMangeApi.getListByDto, {
    params: { ...dto }
  })
/**
 * 获取采购品目限制
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetPurchaseItemLimitNum = () =>
  axios.get(sysContentMangeApi.getPurchaseItemLimitNum)

/**
 * 获取品目数量限制和咨询电话
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetPurchaseItemLimitNumAndConsultTelePhone = () =>
  axios.get(sysContentMangeApi.getPurchaseItemLimitNumAndConsultTelePhone)
